<form [formGroup]="form">
  <mat-toolbar aria-label="Header toolbar" class="h-[65px] pl-8">
    <button
      (click)="triggerToggleMenu()"
      [ngClass]="{ hidden: menuState === 'out' }"
      aria-label="Header toggle sidenav"
      class="mr-4 lg:hidden"
      mat-icon-button
      type="button">
      <mat-icon aria-label="menu closed icon">menu</mat-icon>
    </button>
    <div class="flex w-full items-center justify-between">
      <span
        [ngClass]="{ 'max-[900px]:max-w-20 max-[900px]:truncate max-sm:hidden': menuState === 'out' }"
        aria-label="Navigation item text"
        class="font-light">
        {{ navigationItem.label | translate }}</span
      >
      <span [ngClass]="{ 'max-sm:hidden': menuState === 'out' }" class="min-[800px]:hidden">
        <mat-icon (click)="toggleHeaderMenu()" aria-label="Show more or less icon">{{
          showHeaderOption ? 'expand_less' : 'expand_more'
        }}</mat-icon>
      </span>
      <div class="min-[800px]:flex-end hidden min-[800px]:flex">
        <ng-container *ngTemplateOutlet="headerOptions" />
      </div>
    </div>
  </mat-toolbar>

  <mat-toolbar
    *ngIf="showHeaderOption"
    aria-label="Extended header options toolbar"
    class="hidden p-0 max-[800px]:flex">
    <div class="flex-end flex w-full justify-evenly">
      <ng-container *ngTemplateOutlet="headerOptions" />
    </div>
  </mat-toolbar>
  <ng-template #headerOptions>
    <div *appHideOnRoute="['/sites']">
      <button
        *ngIf="menuItems?.length"
        [matMenuTriggerFor]="itemsMenu"
        [ngClass]="{
          'mx-2': showHeaderOption,
          'mx-4': !showHeaderOption,
          'max-[900px]:max-w-[180px]': menuState === 'out',
          'max-[900px]:max-w-[340px]': menuState !== 'out',
        }"
        class="text-neutral-95 label-start max-w-[340px]"
        aria-label="Header options button"
        mat-stroked-button>
        <div
          class="block max-w-[340px] overflow-hidden text-ellipsis"
          [ngClass]="{
            'max-[900px]:max-w-[180px]': menuState === 'out',
            'max-[900px]:max-w-[340px]': menuState !== 'out',
          }">
          {{ selectedMenuItem }}
        </div>
        <mat-icon aria-label="Arrow dropdown" iconPositionEnd>arrow_drop_down</mat-icon>
      </button>
      <mat-menu #itemsMenu="matMenu" class="max-h-44 overflow-y-scroll" (closed)="onMenuClosed()">
        <!-- Search Input -->
        <div
          (click)="$event.stopPropagation()"
          (keydown)="$event.stopPropagation()"
          tabindex="0"
          class="quick-search mx-1 h-10 items-center rounded-lg">
          <input
            class="h-8 w-full"
            matInput
            [formControl]="searchControl"
            [placeholder]="'global.quickSearch' | translate"
            aria-label="Search menu items" />
          <mat-icon class="mr-2" aria-label="Search icon" matPrefix>search</mat-icon>
        </div>

        <mat-radio-group aria-label="Header menu items group" class="flex w-52 flex-col" formControlName="menuItem">
          <ng-container *ngFor="let item of filteredItems; let i = index; trackBy: trackByIndex">
            <mat-radio-button
              [value]="item"
              [checked]="item === selectedMenuItem"
              aria-label="Header menu item radio button"
              (click)="changeSite(item)">
              <span aria-label="Header menu item label" class="mr-1 block max-w-48 overflow-hidden">
                {{ item }}
              </span>
            </mat-radio-button>
          </ng-container>
        </mat-radio-group>
      </mat-menu>
    </div>

    <button
      (click)="toggleThemeMode()"
      aria-label="Theme change button"
      class="text-neutral-95 mx-2 border border-solid"
      mat-icon-button>
      @if (isDarkMode | async) {
        <mat-icon class="bottom-px right-px" aria-label="Dark mode icon">dark_mode</mat-icon>
      } @else {
        <mat-icon class="bottom-px right-px" aria-label="Light mode icon">light_mode</mat-icon>
      }
    </button>

    <button
      [matMenuTriggerFor]="languageMenu"
      aria-label="Language change button"
      class="text-neutral-95 mx-2 border border-solid"
      mat-icon-button>
      <mat-icon aria-label="Language icon" class="bottom-px right-px">language</mat-icon>
    </button>

    <mat-menu #languageMenu="matMenu">
      <mat-radio-group aria-labelledby="Language menu items" class="flex w-52 flex-col" formControlName="language">
        @for (item of getAvailableLanguages(languages); track item) {
          <mat-radio-button aria-label="Flag radio button" [value]="item" (click)="changeLanguage(item.id)">
            <div class="flex w-36 justify-between">
              {{ item.name }}
              <img aria-label="Flag image" src="assets/flags/{{ item.img }}" alt="flag" />
            </div>
          </mat-radio-button>
        }
        <div class="secondary-sublabel mx-3 my-2 text-sm font-extralight">
          {{ 'launchingSoon' | translate | uppercase }}
        </div>
        @for (item of getLaunchingSoonLanguages(languages); track item) {
          <mat-radio-button [value]="item" disabled>
            <div class="flex w-36 justify-between">
              {{ item.name }}
              <img class="opacity-50" aria-label="Disabled flag icon" src="assets/flags/{{ item.img }}" alt="flag" />
            </div>
          </mat-radio-button>
        }
      </mat-radio-group>
    </mat-menu>

    <app-avatar
      [label]="user.fullName || ''"
      [matMenuTriggerFor]="userInfoMenu"
      aria-label="User avatar"
      backgroundColor="primary-40"
      class="ml-2 mr-4 cursor-pointer"
      color="neutral-90" />
    <mat-menu #userInfoMenu="matMenu" aria-label="User info menu dropdown">
      <div class="mx-3 mb-3 mt-2 w-36 font-normal">
        <div>{{ user.fullName }}</div>
        <div class="text-sm">{{ user.email }}</div>
        <mat-divider />
        <div
          (click)="logout()"
          (keydown)="logout()"
          aria-label="Logout button"
          class="mt-2 flex cursor-pointer items-center justify-between"
          role="button"
          tabindex="0">
          {{ 'Sign Out' | translate }}
          <mat-icon aria-label="signout icon" class="scale-75">logout</mat-icon>
        </div>
      </div>
    </mat-menu>
  </ng-template>
</form>
